import { colors, IMForm, IMInputText, IMSubmitButton } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const IMFormStyled = styled(IMForm)`
  border-radius: 0.6rem;
  padding: 4rem 3rem;
  margin-bottom: 2rem;
  border: 2px solid ${colors.neutral[200]};
  min-width: 100%;
  justify-content: flex-start;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(23rem, 1fr));
  justify-items: center;
  column-gap: 1%;
`;

export const IMInputTextStyled = styled(IMInputText)`
  width: 23rem;
`;

export const IMSubmitButtonStyled = styled(IMSubmitButton)`
  width: 23rem;
  min-width: 15rem;
  margin-top: 2.7rem;
`;
